import React from 'react';
import { Empty } from 'antd';
import { ReactComponent as NoResultsIcon } from '../../../../assets/icons/no_results_icon.svg';
import { ReactComponent as NoResultsIconPurple } from '../../../../assets/icons/no_results_icon_purple.svg';

const NoResults = props => {
  return (
    <Empty
      id="no-results-image" 
      image={props.customColor ? <NoResultsIconPurple/> : <NoResultsIcon />}
      description={
        <>
          <p className={`${props.customColor ? 'no-results-p' : ''}`}>{props.description}</p>
          <span className={`${props.customColor ? 'no-results-span' : ''}`}>{props.subDescription}</span>
        </>
      }
    ></Empty>
  );
};

export default NoResults;
